import cn from '../../../../utils/cn';

export interface DropdownActionsButtonsProps {
  children: React.ReactNode;
  className?: string;
}

const DropdownActionsButtons = ({
  children,
  className,
}: DropdownActionsButtonsProps) => {
  return (
    <div className={cn('flex items-center justify-between gap-2.5', className)}>
      {children}
    </div>
  );
};

export default DropdownActionsButtons;
